module.exports = __webpack_public_path__ + "static/media/muscle.ead57951.glb";